var getLayoutForPosition = function getLayoutForPosition(position) {
  switch (position) {
    case 'top':
    case 'bottom':
      return 'horizontal';

    case 'left':
    case 'right':
      return 'vertical';
  }
};

export default getLayoutForPosition;